import { getPost, updatePost } from "./postAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    post: {},
    isLoading: false,
    isError: false,
    error: "",
    isUpdating:false
};

// async thunk
export const fetchPost = createAsyncThunk("post/fetchPost", async (id) => {
    return await getPost(id);
});

export const updatePostAsync = createAsyncThunk('post/updatePost', async ({ id, fieldName, value }) => {
    return await updatePost(id, fieldName, value)
})

const postSlice = createSlice({
    name: "post",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchPost.pending, (state) => {
                state.post = {}
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchPost.fulfilled, (state, action) => {
                state.isLoading = false;
                state.post = action.payload;
            })
            .addCase(fetchPost.rejected, (state, action) => {
                state.isLoading = false;
                state.post = {};
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(updatePostAsync.pending, (state, action) => {
                state.isUpdating=true;
            })
            .addCase(updatePostAsync.fulfilled, (state, action) => {
                state.isUpdating=false;
                state.post.isSaved=action.payload.isSaved;
                state.post.likes=action.payload.likes;
            })
            .addCase(updatePostAsync.rejected, (state, action) => {
                state.isUpdating=false;
                state.error=action.error?.message;
            })
    },
});

export default postSlice.reducer;
